// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFieldStateType } from './IFieldStateType';
import {
    IFieldStateTypeFromJSON,
    IFieldStateTypeFromJSONTyped,
    IFieldStateTypeToJSON,
    IFieldStateTypeToJSONTyped,
} from './IFieldStateType';

/**
 * 
 * @export
 * @interface IAllowDependentCardInfoDto
 */
export interface IAllowDependentCardInfoDto {
    /**
     * 
     * @type {boolean}
     * @memberof IAllowDependentCardInfoDto
     */
    allow_dependent_card: boolean;
    /**
     * 
     * @type {IFieldStateType}
     * @memberof IAllowDependentCardInfoDto
     */
    allow_dependent_card_state?: IFieldStateType;
}



/**
 * Check if a given object implements the IAllowDependentCardInfoDto interface.
 */
export function instanceOfIAllowDependentCardInfoDto(value: object): value is IAllowDependentCardInfoDto {
    if (!('allow_dependent_card' in value) || value['allow_dependent_card'] === undefined) return false;
    return true;
}

export function IAllowDependentCardInfoDtoFromJSON(json: any): IAllowDependentCardInfoDto {
    return IAllowDependentCardInfoDtoFromJSONTyped(json, false);
}

export function IAllowDependentCardInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAllowDependentCardInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'allow_dependent_card': json['allow_dependent_card'],
        'allow_dependent_card_state': json['allow_dependent_card_state'] == null ? undefined : IFieldStateTypeFromJSON(json['allow_dependent_card_state']),
    };
}

export function IAllowDependentCardInfoDtoToJSON(json: any): IAllowDependentCardInfoDto {
    return IAllowDependentCardInfoDtoToJSONTyped(json, false);
}

export function IAllowDependentCardInfoDtoToJSONTyped(value?: IAllowDependentCardInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'allow_dependent_card': value['allow_dependent_card'],
        'allow_dependent_card_state': IFieldStateTypeToJSON(value['allow_dependent_card_state']),
    };
}

